import React from 'react';
import Crossword from '@jaredreisinger/react-crossword';
import {ACROSS, DOWN} from '../../constants/crosswordConstant';
import styled from 'styled-components';


const CrosswordPuzzleStyled = styled.div`
.direction {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    
    > div {
        padding-right: 20px;
    }
    h3 {
        width: 100%;
    }
}
`

function CrosswordPuzzle() {
  const data = {
    across: ACROSS,
    down: DOWN,
  };

  return <>
    <CrosswordPuzzleStyled>
      <Crossword data={data} useStorage={false}/>
    </CrosswordPuzzleStyled>
  </>;
}

export default CrosswordPuzzle;